module.exports = __webpack_public_path__ + "img/upute.2dd0f539.png";